import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  track(event) {
    const eventName = event.params.eventName
    if (!eventName) return

    this.post(eventName)
  }

  post(eventName) {
    const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

    fetch("/customer-flow-events", {
      method: "POST",
      credentials: "same-origin",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken || ""
      },
      body: JSON.stringify({
        customer_flow_event: {
          event_name: eventName
        }
      })
    }).catch(() => {})
  }
}
